import {
  PayloadAction,
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import CreditRepository from "./CreditRepository";
import { RootState } from "../../app/store";

export interface SpentCredit {
  id: number;
  productName: string;
  creditsSpent: number;
  date: string;
  productType: string;
  fornitore: string;
}

export const getSpentCreditsAsync = createAsyncThunk(
  "spentCredits/getSpentCredits",
  async (data: { tenantId: number; userId: number }) => {
    const creditRepository = new CreditRepository();
    const response = await creditRepository.getSpentCredits(data.tenantId, data.userId);
    return response.data || [];
  }
);

const spentCreditsAdapter = createEntityAdapter<SpentCredit>({
  selectId: (spentCredit) => spentCredit.id,
});

export const spentCreditsSlice = createSlice({
  name: "spentCredits",
  initialState: spentCreditsAdapter.getInitialState({
    status: "idle",
    reasonCode: "",
  }),
  reducers: {
    spentCreditsEmptyState: (state) => {
      spentCreditsAdapter.setAll(state, []);
      state.reasonCode = "";
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getSpentCreditsAsync.fulfilled,
        (state: any, action: PayloadAction<SpentCredit[]>) => {
          spentCreditsAdapter.setAll(state, action.payload ?? []);
          state.status = "idle";
        }
      )
      .addCase(getSpentCreditsAsync.pending, (state: any) => {
        state.status = "loading";
      })
      .addCase(getSpentCreditsAsync.rejected, (state: any) => {
        state.status = "failed";
        state.reasonCode = "";
      });
  },
});

export const spentCreditsSelector =
  spentCreditsAdapter.getSelectors<RootState>((state) => state.spentCredits);

export const { spentCreditsEmptyState } = spentCreditsSlice.actions;
export const selectSpentCreditsSliceStatus = (state: any) =>
  state.spentCredits.status;
export const selectSpentCreditsSliceReasonCode = (state: any) =>
  state.spentCredits.reasonCode;

export default spentCreditsSlice.reducer;